import React from 'react';

const BanIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="490"
    height="490"
    viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <g fill="#3FB0E8">
        <g>
          <g>
            <g>
              <g>
                <g>
                  <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm0 1.6c2.49-.002 4.896.896 6.776 2.528L4.072 18.712C1.462 15.622.879 11.299 2.58 7.628 4.28 3.958 7.955 1.606 12 1.6zm0 20.8c-2.5 0-4.916-.907-6.8-2.552L19.904 5.256c2.628 3.086 3.225 7.417 1.528 11.098-1.697 3.681-5.379 6.04-9.432 6.046z" transform="translate(-1094 -730) translate(135 370) translate(378 301) translate(10 41) translate(541 10) translate(30 8)"/>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default BanIcon;
